import { ApolloError } from '@apollo/client';
import { logError } from '@zg-rentals/log-error';
import { getCurrentSessionURL } from './fullStory';

const isUserAuthError = (err: any) => hasWordInErrorMessage(err, 'user');

const hasWordInErrorMessage = (err: Error, word: string) => {
  if (!err || !err.message) {
    return false;
  }

  const lowercaseMessage = err.message.toLowerCase();
  return lowercaseMessage.indexOf(word) > -1;
};

const logApolloError = (error: ApolloError, context: Record<string, unknown>) => {
  const fullStorySessionUrl = getCurrentSessionURL();
  // Apollo errors do not have a custom name; explicitly tag Marlin events with "ApolloError"
  logError({ error, context: { ...context, fullStorySessionUrl }, errorType: 'ApolloError' });
};

export { isUserAuthError, logApolloError };
